// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const AddonActivationStatus = {
    ADDON_ACTIVATION_STATUS_PENDING: 'ADDON_ACTIVATION_STATUS_PENDING',
    ADDON_ACTIVATION_STATUS_FAILURE: 'ADDON_ACTIVATION_STATUS_FAILURE',
    ADDON_ACTIVATION_STATUS_SUCCESS: 'ADDON_ACTIVATION_STATUS_SUCCESS',
};
export const AddonActivationStatusValue = {
    ADDON_ACTIVATION_STATUS_PENDING: 0,
    ADDON_ACTIVATION_STATUS_FAILURE: 1,
    ADDON_ACTIVATION_STATUS_SUCCESS: 2,
};
export const SubscriptionLevel = {
    SUBSCRIPTION_LEVEL_BASIC: 'SUBSCRIPTION_LEVEL_BASIC',
    SUBSCRIPTION_LEVEL_PROFESSIONAL: 'SUBSCRIPTION_LEVEL_PROFESSIONAL',
    SUBSCRIPTION_LEVEL_ENTERPRISE: 'SUBSCRIPTION_LEVEL_ENTERPRISE',
    SUBSCRIPTION_LEVEL_LITE: 'SUBSCRIPTION_LEVEL_LITE',
    SUBSCRIPTION_LEVEL_PREMIUM: 'SUBSCRIPTION_LEVEL_PREMIUM',
    SUBSCRIPTION_LEVEL_ELITE: 'SUBSCRIPTION_LEVEL_ELITE',
    SUBSCRIPTION_LEVEL_FREE: 'SUBSCRIPTION_LEVEL_FREE',
    SUBSCRIPTION_LEVEL_STARTER: 'SUBSCRIPTION_LEVEL_STARTER',
    SUBSCRIPTION_LEVEL_BASIC_PLUS: 'SUBSCRIPTION_LEVEL_BASIC_PLUS',
    SUBSCRIPTION_LEVEL_PROFESSIONAL_PLUS: 'SUBSCRIPTION_LEVEL_PROFESSIONAL_PLUS',
    SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS: 'SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS',
    SUBSCRIPTION_LEVEL_REPLACED_BY_SUBSCRIPTION_TIERS: 'SUBSCRIPTION_LEVEL_REPLACED_BY_SUBSCRIPTION_TIERS',
    SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS_PILOT: 'SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS_PILOT',
};
export const SubscriptionLevelValue = {
    SUBSCRIPTION_LEVEL_BASIC: 0,
    SUBSCRIPTION_LEVEL_PROFESSIONAL: 1,
    SUBSCRIPTION_LEVEL_ENTERPRISE: 2,
    SUBSCRIPTION_LEVEL_LITE: 3,
    SUBSCRIPTION_LEVEL_PREMIUM: 4,
    SUBSCRIPTION_LEVEL_ELITE: 5,
    SUBSCRIPTION_LEVEL_FREE: 6,
    SUBSCRIPTION_LEVEL_STARTER: 7,
    SUBSCRIPTION_LEVEL_BASIC_PLUS: 8,
    SUBSCRIPTION_LEVEL_PROFESSIONAL_PLUS: 9,
    SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS: 10,
    SUBSCRIPTION_LEVEL_REPLACED_BY_SUBSCRIPTION_TIERS: 11,
    SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS_PILOT: 12,
};
export const PartnerType = {
    PARTNER_TYPE_UNSPECIFIED: 'PARTNER_TYPE_UNSPECIFIED',
    PARTNER_TYPE_AGENCY: 'PARTNER_TYPE_AGENCY',
    PARTNER_TYPE_ENTERPRISE: 'PARTNER_TYPE_ENTERPRISE',
};
export const PartnerTypeValue = {
    PARTNER_TYPE_UNSPECIFIED: 0,
    PARTNER_TYPE_AGENCY: 1,
    PARTNER_TYPE_ENTERPRISE: 2,
};
export const BillingFrequency = {
    BILLING_FREQUENCY_INVALID: 'BILLING_FREQUENCY_INVALID',
    BILLING_FREQUENCY_MONTHLY: 'BILLING_FREQUENCY_MONTHLY',
    BILLING_FREQUENCY_YEARLY: 'BILLING_FREQUENCY_YEARLY',
};
export const BillingFrequencyValue = {
    BILLING_FREQUENCY_INVALID: 0,
    BILLING_FREQUENCY_MONTHLY: 1,
    BILLING_FREQUENCY_YEARLY: 2,
};
export const SubscriptionTierUpdateType = {
    SUBSCRIPTION_TIER_UPDATE_TYPE_INVALID: 'SUBSCRIPTION_TIER_UPDATE_TYPE_INVALID',
    SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_PAID: 'SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_PAID',
    SUBSCRIPTION_TIER_UPDATE_TYPE_SWITCH_FREE_TRIAL: 'SUBSCRIPTION_TIER_UPDATE_TYPE_SWITCH_FREE_TRIAL',
    SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL: 'SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL',
    SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL_FAILED_PAYMENT: 'SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL_FAILED_PAYMENT',
    SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_FREE_TRIAL: 'SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_FREE_TRIAL',
    SUBSCRIPTION_TIER_UPDATE_TYPE_PAID_TO_PAID: 'SUBSCRIPTION_TIER_UPDATE_TYPE_PAID_TO_PAID',
};
export const SubscriptionTierUpdateTypeValue = {
    SUBSCRIPTION_TIER_UPDATE_TYPE_INVALID: 0,
    SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_PAID: 1,
    SUBSCRIPTION_TIER_UPDATE_TYPE_SWITCH_FREE_TRIAL: 2,
    SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL: 3,
    SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL_FAILED_PAYMENT: 4,
    SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_FREE_TRIAL: 5,
    SUBSCRIPTION_TIER_UPDATE_TYPE_PAID_TO_PAID: 6,
};
export const UpdateSubscriptionTierStatus = {
    UPDATE_SUBSCRIPTION_TIER_STATUS_INVALID: 'UPDATE_SUBSCRIPTION_TIER_STATUS_INVALID',
    UPDATE_SUBSCRIPTION_TIER_STATUS_UNSET: 'UPDATE_SUBSCRIPTION_TIER_STATUS_UNSET',
    UPDATE_SUBSCRIPTION_TIER_STATUS_PROCESSING: 'UPDATE_SUBSCRIPTION_TIER_STATUS_PROCESSING',
    UPDATE_SUBSCRIPTION_TIER_STATUS_SUCCESS: 'UPDATE_SUBSCRIPTION_TIER_STATUS_SUCCESS',
    UPDATE_SUBSCRIPTION_TIER_STATUS_FAILURE: 'UPDATE_SUBSCRIPTION_TIER_STATUS_FAILURE',
};
export const UpdateSubscriptionTierStatusValue = {
    UPDATE_SUBSCRIPTION_TIER_STATUS_INVALID: 0,
    UPDATE_SUBSCRIPTION_TIER_STATUS_UNSET: 1,
    UPDATE_SUBSCRIPTION_TIER_STATUS_PROCESSING: 2,
    UPDATE_SUBSCRIPTION_TIER_STATUS_SUCCESS: 3,
    UPDATE_SUBSCRIPTION_TIER_STATUS_FAILURE: 4,
};
export const Action = {
    ACTION_UNSPECIFIED: 'ACTION_UNSPECIFIED',
    ACTION_CREATE_SNAPSHOT_REPORT: 'ACTION_CREATE_SNAPSHOT_REPORT',
    ACTION_CREATE_SNAPSHOT_REPORT_BULK: 'ACTION_CREATE_SNAPSHOT_REPORT_BULK',
    ACTION_ACTIVATE_RM: 'ACTION_ACTIVATE_RM',
    ACTION_ACTIVATE_DEMO_RM: 'ACTION_ACTIVATE_DEMO_RM',
    ACTION_ACTIVATE_SM: 'ACTION_ACTIVATE_SM',
    ACTION_ACTIVATE_MS: 'ACTION_ACTIVATE_MS',
    ACTION_CONVERT_DEMO_RM: 'ACTION_CONVERT_DEMO_RM',
    ACTION_ACTIVATE_MARKETPLACE_PRODUCT: 'ACTION_ACTIVATE_MARKETPLACE_PRODUCT',
    ACTION_REFRESH_SNAPSHOT_REPORT: 'ACTION_REFRESH_SNAPSHOT_REPORT',
    ACTION_ACTIVATE_LISTING_DISTRIBUTION: 'ACTION_ACTIVATE_LISTING_DISTRIBUTION',
    ACTION_ACTIVATE_LISTING_SYNC_PRO: 'ACTION_ACTIVATE_LISTING_SYNC_PRO',
    ACTION_ACTIVATE_CUSTOM_PRODUCT: 'ACTION_ACTIVATE_CUSTOM_PRODUCT',
    ACTION_ACCESS_SNAPSHOT_WIDGET: 'ACTION_ACCESS_SNAPSHOT_WIDGET',
    ACTION_ACTIVATE_ADDON: 'ACTION_ACTIVATE_ADDON',
};
export const ActionValue = {
    ACTION_UNSPECIFIED: 0,
    ACTION_CREATE_SNAPSHOT_REPORT: 1,
    ACTION_CREATE_SNAPSHOT_REPORT_BULK: 2,
    ACTION_ACTIVATE_RM: 3,
    ACTION_ACTIVATE_DEMO_RM: 4,
    ACTION_ACTIVATE_SM: 5,
    ACTION_ACTIVATE_MS: 6,
    ACTION_CONVERT_DEMO_RM: 7,
    ACTION_ACTIVATE_MARKETPLACE_PRODUCT: 8,
    ACTION_REFRESH_SNAPSHOT_REPORT: 9,
    ACTION_ACTIVATE_LISTING_DISTRIBUTION: 10,
    ACTION_ACTIVATE_LISTING_SYNC_PRO: 11,
    ACTION_ACTIVATE_CUSTOM_PRODUCT: 12,
    ACTION_ACCESS_SNAPSHOT_WIDGET: 13,
    ACTION_ACTIVATE_ADDON: 14,
};
export const AccessLevel = {
    ACCESS_LEVEL_ALPHA: 'ACCESS_LEVEL_ALPHA',
    ACCESS_LEVEL_BETA: 'ACCESS_LEVEL_BETA',
    ACCESS_LEVEL_ALL: 'ACCESS_LEVEL_ALL',
    ACCESS_LEVEL_EXPERIMENT: 'ACCESS_LEVEL_EXPERIMENT',
};
export const AccessLevelValue = {
    ACCESS_LEVEL_ALPHA: 0,
    ACCESS_LEVEL_BETA: 1,
    ACCESS_LEVEL_ALL: 2,
    ACCESS_LEVEL_EXPERIMENT: 3,
};
export const Expiration = {
    EXPIRATION_INVALID: 'EXPIRATION_INVALID',
    EXPIRATION_UNSET: 'EXPIRATION_UNSET',
    EXPIRATION_TWO_WEEKS: 'EXPIRATION_TWO_WEEKS',
    EXPIRATION_FOUR_WEEKS: 'EXPIRATION_FOUR_WEEKS',
    EXPIRATION_TWELVE_WEEKS: 'EXPIRATION_TWELVE_WEEKS',
    EXPIRATION_TWENTY_FOUR_WEEKS: 'EXPIRATION_TWENTY_FOUR_WEEKS',
    EXPIRATION_ONE_MINUTE: 'EXPIRATION_ONE_MINUTE',
};
export const ExpirationValue = {
    EXPIRATION_INVALID: 0,
    EXPIRATION_UNSET: 1,
    EXPIRATION_TWO_WEEKS: 2,
    EXPIRATION_FOUR_WEEKS: 3,
    EXPIRATION_TWELVE_WEEKS: 4,
    EXPIRATION_TWENTY_FOUR_WEEKS: 5,
    EXPIRATION_ONE_MINUTE: 6,
};
export const ReportAccessScope = {
    REPORT_ACCESS_SCOPE_UNSET: 'REPORT_ACCESS_SCOPE_UNSET',
    REPORT_ACCESS_SCOPE_NO_ACCESS: 'REPORT_ACCESS_SCOPE_NO_ACCESS',
    REPORT_ACCESS_SCOPE_VIEW: 'REPORT_ACCESS_SCOPE_VIEW',
    REPORT_ACCESS_SCOPE_EDIT: 'REPORT_ACCESS_SCOPE_EDIT',
};
export const ReportAccessScopeValue = {
    REPORT_ACCESS_SCOPE_UNSET: 0,
    REPORT_ACCESS_SCOPE_NO_ACCESS: 1,
    REPORT_ACCESS_SCOPE_VIEW: 2,
    REPORT_ACCESS_SCOPE_EDIT: 3,
};
export const ReportAccessIDType = {
    REPORT_ACCESS_ID_TYPE_UNSET: 'REPORT_ACCESS_ID_TYPE_UNSET',
    REPORT_ACCESS_ID_TYPE_REPORT: 'REPORT_ACCESS_ID_TYPE_REPORT',
    REPORT_ACCESS_ID_TYPE_REPORT_CATEGORY: 'REPORT_ACCESS_ID_TYPE_REPORT_CATEGORY',
};
export const ReportAccessIDTypeValue = {
    REPORT_ACCESS_ID_TYPE_UNSET: 0,
    REPORT_ACCESS_ID_TYPE_REPORT: 1,
    REPORT_ACCESS_ID_TYPE_REPORT_CATEGORY: 2,
};
export const PartnerHealthState = {
    PARTNER_HEALTH_STATE_HEALTHY: 'PARTNER_HEALTH_STATE_HEALTHY',
    PARTNER_HEALTH_STATE_AT_RISK: 'PARTNER_HEALTH_STATE_AT_RISK',
    PARTNER_HEALTH_STATE_RESTRICTED: 'PARTNER_HEALTH_STATE_RESTRICTED',
};
export const PartnerHealthStateValue = {
    PARTNER_HEALTH_STATE_HEALTHY: 0,
    PARTNER_HEALTH_STATE_AT_RISK: 1,
    PARTNER_HEALTH_STATE_RESTRICTED: 2,
};
export const PartnerHealthSubState = {
    PARTNER_HEALTH_SUB_STATE_UNSPECIFIED: 'PARTNER_HEALTH_SUB_STATE_UNSPECIFIED',
    PARTNER_HEALTH_SUB_STATE_ACTIVE: 'PARTNER_HEALTH_SUB_STATE_ACTIVE',
    PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_OVERDUE: 'PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_OVERDUE',
    PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_SUSPENDED: 'PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_SUSPENDED',
    PARTNER_HEALTH_SUB_STATE_PAYMENT_PLAN: 'PARTNER_HEALTH_SUB_STATE_PAYMENT_PLAN',
};
export const PartnerHealthSubStateValue = {
    PARTNER_HEALTH_SUB_STATE_UNSPECIFIED: 0,
    PARTNER_HEALTH_SUB_STATE_ACTIVE: 1,
    PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_OVERDUE: 2,
    PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_SUSPENDED: 3,
    PARTNER_HEALTH_SUB_STATE_PAYMENT_PLAN: 4,
};
export const PartnerOrigin = {
    PARTNER_ORIGIN_INVALID: 'PARTNER_ORIGIN_INVALID',
    PARTNER_ORIGIN_UNSET: 'PARTNER_ORIGIN_UNSET',
    PARTNER_ORIGIN_INTERNAL: 'PARTNER_ORIGIN_INTERNAL',
    PARTNER_ORIGIN_SELF_SIGN_UP: 'PARTNER_ORIGIN_SELF_SIGN_UP',
};
export const PartnerOriginValue = {
    PARTNER_ORIGIN_INVALID: 0,
    PARTNER_ORIGIN_UNSET: 1,
    PARTNER_ORIGIN_INTERNAL: 2,
    PARTNER_ORIGIN_SELF_SIGN_UP: 3,
};
export const Status = {
    STATUS_INVALID: 'STATUS_INVALID',
    STATUS_IN_PROGRESS: 'STATUS_IN_PROGRESS',
    STATUS_COMPLETE: 'STATUS_COMPLETE',
    STATUS_ERROR: 'STATUS_ERROR',
};
export const StatusValue = {
    STATUS_INVALID: 0,
    STATUS_IN_PROGRESS: 1,
    STATUS_COMPLETE: 2,
    STATUS_ERROR: 3,
};
export const SupportFlag = {
    SUPPORT_FLAG_INVALID: 'SUPPORT_FLAG_INVALID',
    SUPPORT_FLAG_UNSET: 'SUPPORT_FLAG_UNSET',
    SUPPORT_FLAG_TRUE: 'SUPPORT_FLAG_TRUE',
    SUPPORT_FLAG_FALSE: 'SUPPORT_FLAG_FALSE',
};
export const SupportFlagValue = {
    SUPPORT_FLAG_INVALID: 0,
    SUPPORT_FLAG_UNSET: 1,
    SUPPORT_FLAG_TRUE: 2,
    SUPPORT_FLAG_FALSE: 3,
};
export const GetSignUpAddPaymentCardResultResponseStatus = {
    GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_INVALID: 'GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_INVALID',
    GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_OK: 'GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_OK',
    GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_HAS_ERROR: 'GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_HAS_ERROR',
};
export const GetSignUpAddPaymentCardResultResponseStatusValue = {
    GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_INVALID: 0,
    GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_OK: 1,
    GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_HAS_ERROR: 2,
};
export const RewardStatus = {
    REWARD_STATUS_INVALID: 'REWARD_STATUS_INVALID',
    REWARD_STATUS_UNSET: 'REWARD_STATUS_UNSET',
    REWARD_STATUS_INELIGIBLE: 'REWARD_STATUS_INELIGIBLE',
    REWARD_STATUS_ELIGIBLE: 'REWARD_STATUS_ELIGIBLE',
    REWARD_STATUS_PROCESSING_CLAIM: 'REWARD_STATUS_PROCESSING_CLAIM',
    REWARD_STATUS_CLAIMED: 'REWARD_STATUS_CLAIMED',
};
export const RewardStatusValue = {
    REWARD_STATUS_INVALID: 0,
    REWARD_STATUS_UNSET: 1,
    REWARD_STATUS_INELIGIBLE: 2,
    REWARD_STATUS_ELIGIBLE: 3,
    REWARD_STATUS_PROCESSING_CLAIM: 4,
    REWARD_STATUS_CLAIMED: 5,
};
export const SubscriptionFailure = {
    SUBSCRIPTION_FAILURE_NONE: 'SUBSCRIPTION_FAILURE_NONE',
    SUBSCRIPTION_FAILURE_OVERDUE: 'SUBSCRIPTION_FAILURE_OVERDUE',
};
export const SubscriptionFailureValue = {
    SUBSCRIPTION_FAILURE_NONE: 0,
    SUBSCRIPTION_FAILURE_OVERDUE: 1,
};
export const SalesSetting = {
    SALES_SETTING_INVALID: 'SALES_SETTING_INVALID',
    SALES_SETTING_ENABLED: 'SALES_SETTING_ENABLED',
    SALES_SETTING_DISABLED: 'SALES_SETTING_DISABLED',
    SALES_SETTING_UNSET: 'SALES_SETTING_UNSET',
};
export const SalesSettingValue = {
    SALES_SETTING_INVALID: 0,
    SALES_SETTING_ENABLED: 1,
    SALES_SETTING_DISABLED: 2,
    SALES_SETTING_UNSET: 3,
};
export const TimeRange = {
    TIME_RANGE_SEVEN_DAYS: 'TIME_RANGE_SEVEN_DAYS',
    TIME_RANGE_THIRTY_DAYS: 'TIME_RANGE_THIRTY_DAYS',
    TIME_RANGE_NINETY_DAYS: 'TIME_RANGE_NINETY_DAYS',
    TIME_RANGE_SIX_MONTHS: 'TIME_RANGE_SIX_MONTHS',
    TIME_RANGE_TWELVE_MONTHS: 'TIME_RANGE_TWELVE_MONTHS',
    TIME_RANGE_UNSPECIFIED: 'TIME_RANGE_UNSPECIFIED',
};
export const TimeRangeValue = {
    TIME_RANGE_SEVEN_DAYS: 0,
    TIME_RANGE_THIRTY_DAYS: 1,
    TIME_RANGE_NINETY_DAYS: 2,
    TIME_RANGE_SIX_MONTHS: 3,
    TIME_RANGE_TWELVE_MONTHS: 4,
    TIME_RANGE_UNSPECIFIED: 5,
};
export const TaskStatus = {
    TASK_STATUS_INVALID: 'TASK_STATUS_INVALID',
    TASK_STATUS_UNSET: 'TASK_STATUS_UNSET',
    TASK_STATUS_INCOMPLETE: 'TASK_STATUS_INCOMPLETE',
    TASK_STATUS_COMPLETE: 'TASK_STATUS_COMPLETE',
};
export const TaskStatusValue = {
    TASK_STATUS_INVALID: 0,
    TASK_STATUS_UNSET: 1,
    TASK_STATUS_INCOMPLETE: 2,
    TASK_STATUS_COMPLETE: 3,
};
export const Usage = {
    USAGE_INVALID: 'USAGE_INVALID',
    USAGE_REQUIRED: 'USAGE_REQUIRED',
    USAGE_OPTIONAL: 'USAGE_OPTIONAL',
    USAGE_DISABLED: 'USAGE_DISABLED',
};
export const UsageValue = {
    USAGE_INVALID: 0,
    USAGE_REQUIRED: 1,
    USAGE_OPTIONAL: 2,
    USAGE_DISABLED: 3,
};
export const UITheme = {
    UI_THEME_INVALID: 'UI_THEME_INVALID',
    UI_THEME_DARK: 'UI_THEME_DARK',
    UI_THEME_LIGHT: 'UI_THEME_LIGHT',
    UI_THEME_USER_PREFERENCE: 'UI_THEME_USER_PREFERENCE',
};
export const UIThemeValue = {
    UI_THEME_INVALID: 0,
    UI_THEME_DARK: 1,
    UI_THEME_LIGHT: 2,
    UI_THEME_USER_PREFERENCE: 3,
};
export const Field = {
    FIELD_INVALID: 'FIELD_INVALID',
    FIELD_LOGO_URL: 'FIELD_LOGO_URL',
    FIELD_FAVICON_URL: 'FIELD_FAVICON_URL',
    FIELD_SHORTCUT_ICON_URL: 'FIELD_SHORTCUT_ICON_URL',
    FIELD_UI_THEME: 'FIELD_UI_THEME',
    FIELD_PRIMARY_COLOR: 'FIELD_PRIMARY_COLOR',
    FIELD_NAME: 'FIELD_NAME',
    FIELD_DARK_MODE_LOGO_URL: 'FIELD_DARK_MODE_LOGO_URL',
    FIELD_BUSINESS_APP_UI_THEME: 'FIELD_BUSINESS_APP_UI_THEME',
};
export const FieldValue = {
    FIELD_INVALID: 0,
    FIELD_LOGO_URL: 1,
    FIELD_FAVICON_URL: 2,
    FIELD_SHORTCUT_ICON_URL: 3,
    FIELD_UI_THEME: 4,
    FIELD_PRIMARY_COLOR: 5,
    FIELD_NAME: 6,
    FIELD_DARK_MODE_LOGO_URL: 7,
    FIELD_BUSINESS_APP_UI_THEME: 8,
};
export const NavigationItemBadge = {
    NAVIGATION_ITEM_BADGE_NONE: 'NAVIGATION_ITEM_BADGE_NONE',
    NAVIGATION_ITEM_BADGE_NEW: 'NAVIGATION_ITEM_BADGE_NEW',
    NAVIGATION_ITEM_BADGE_BETA: 'NAVIGATION_ITEM_BADGE_BETA',
};
export const NavigationItemBadgeValue = {
    NAVIGATION_ITEM_BADGE_NONE: 0,
    NAVIGATION_ITEM_BADGE_NEW: 1,
    NAVIGATION_ITEM_BADGE_BETA: 2,
};
export const SegmentedOnboardingConfiguration = {
    SEGMENTED_ONBOARDING_UNSET: 'SEGMENTED_ONBOARDING_UNSET',
    SEGMENTED_ONBOARDING_OPTIONAL: 'SEGMENTED_ONBOARDING_OPTIONAL',
    SEGMENTED_ONBOARDING_REQUIRED: 'SEGMENTED_ONBOARDING_REQUIRED',
    SEGMENTED_ONBOARDING_DISABLED: 'SEGMENTED_ONBOARDING_DISABLED',
};
export const SegmentedOnboardingConfigurationValue = {
    SEGMENTED_ONBOARDING_UNSET: 0,
    SEGMENTED_ONBOARDING_OPTIONAL: 1,
    SEGMENTED_ONBOARDING_REQUIRED: 2,
    SEGMENTED_ONBOARDING_DISABLED: 3,
};
export const BrandingUITheme = {
    Dark: 'Dark',
    Light: 'Light',
};
export const BrandingUIThemeValue = {
    Dark: 0,
    Light: 1,
};
